module.exports = __webpack_public_path__ + "static/media/profile.1e07be6a.svg";